<template>
  <div id="app" class="font-sans antialiased overflow-hidden">

    <header class="p-5 pb-0 sm:p-10">
      <h1 class="text-2xl font-bold">Yet Another QrCode Generator</h1>
      <h2 class="text-md font-bold uppercase">No trackers | No redirections | No expirations</h2>
    </header>

    <div class="flex flex-wrap ">
      <div class="w-full sm:w-1/2 p-5 sm:p-10">

        <div>
          <label for="type">Output Type</label>
          <select name="type" id="type" v-model="tag">
            <option value="img">Image (PNG)</option>
            <option value="svg">SVG</option>
            <option value="canvas">Canvas</option>
          </select>
        </div>

        <div>
          <label for="codeValue">Value</label>
          <input id="codeValue" type="text" v-model="value" placeholder="https://yoursite.org" class="font-bold"/>
        </div>

        <div>
          <label for="correctionLevel">Error Correction Level</label>
          <select name="correctionLevel" id="correctionLevel" v-model="options.errorCorrectionLevel">
            <option value="H">High</option>
            <option value="Q">Quartile</option>
            <option value="M">Medium</option>
            <option value="L">Low</option>
          </select>
        </div>

        <div>
          <label for="maskPattern">Mask Pattern</label>
          <select name="maskPattern" id="maskPattern" v-model="options.maskPattern">
            <option value="">auto</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
          </select>
        </div>

        <div>
          <label for="qrMargin">Margin</label>
          <input id="qrMargin" type="number" v-model="options.margin"/>
        </div>
        <div>
          <label for="qrScale">Scale</label>
          <input id="qrScale" type="number" v-model="options.scale"/>
        </div>
        <div>
          <label for="qrWidth">Width</label>
          <input class="mb-0" id="qrWidth" type="number" v-model="options.width" :disabled="tag === 'svg'"
                 :placeholder="(tag === 'svg') ? 'Not available with SVG type' : ''"/>
        </div>
        <div>
          <label for="qrColor__dark">Dark Color</label>
          <input id="qrColor__dark" type="text" v-model="options.color.dark"/>
        </div>
        <div>
          <label for="qrColor__light"> Light Color</label>
          <input id="qrColor__light" type="text" v-model="options.color.light"/>
        </div>
      </div>

      <div class="w-full sm:w-1/2 p-5 sm:p-10 text-center max-w-lg">
        <qrcode ref="qrc" :value="value" :options="options" :tag="tag" :key="codeKey"></qrcode>
        <p class="text-sm text-gray-700">Note: don't trust the apparent width <br>(The QR code is contained in the available
          screen space).</p>

        <button
            class="mt-5 bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-500 active:bg-blue-700 focus:outline-none"
            @click="download" v-show="this.tag !== 'canvas'">Download
        </button>
      </div>
    </div>


    <footer class="mt-5 p-5 sm:p-10">
      <div>
        Made with
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 inline-block text-red-600" viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
      </span>
        and in a hurry by <a href="https://github.com/linuslabo">linuslabo</a>.
      </div>
      <div>Qr Codes generated by the amazing <a href="https://github.com/fengyuanchen/vue-qrcode">fengyuanchen's
        vue-qrcode</a>.
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

export default {
  name: 'App',
  components: {},
  data() {
    return {
      message: 'Hello Vue!',
      value: 'Your text here!',
      tag: 'img',
      codeKey: 0,
      options: {
        errorCorrectionLevel: 'H',
        maskPattern: '',
        margin: 4,
        scale: 4,
        width: '500',
        color: {
          dark: '#000000',
          light: '#ffffffff'
        },
      }
    }
  },
  watch: {
    tag: function (newVal) {
      switch (newVal) {
        case 'canvas':
        case 'img':
          this.options.width = 500;
          break;
        case 'svg':
          this.options.width = undefined;
          break;
      }
      this.codeKey++;
    }
  },
  methods: {
    download: function () {
      switch (this.tag) {
        case 'svg':
          this.downloadSvg(this.$refs.qrc.$el.firstChild, 'qrCode.svg');
          break;
        case 'img':
          this.downloadPng(this.$refs.qrc.$el, 'qrCode.png');
          break;
      }
    },

    downloadSvg(svgEl, name) {
      svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      let svgData = svgEl.outerHTML;
      let preface = '<?xml version="1.0" standalone="no"?>\r\n';
      let svgBlob = new Blob([preface, svgData], {type: "image/svg+xml;charset=utf-8"});
      let svgUrl = URL.createObjectURL(svgBlob);

      this.generateDownloadLink(svgUrl, name);
    },

    downloadPng(imgEl, name) {
      this.generateDownloadLink(imgEl.src, name)
    },

    generateDownloadLink(content, name) {
      let downloadLink = document.createElement("a");
      downloadLink.href = content;
      downloadLink.download = name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
}
</script>